import store from '@/store'
import { NavigationGuard } from 'vue-router'
import { MemberType } from '@/types/generated/graphql'

const authorizedTo = (memberType: MemberType) => {
  return store.getters['auth/authorizedTo'](memberType)
}

export const memberGuard: NavigationGuard = (to, from, next) => {
  if (to.meta.memberType && !authorizedTo(to.meta.memberType)) {
    next({ name: 'NotFound' })
  } else {
    next()
  }
}
